import { request } from '@/lib/request'
import { sharePromise } from '@/lib/share-promise'
import type { UserInfo } from '@/routes/app'
import type { FrontEndConfigVO } from '@/service/cross-border-api'
import { useRequest } from 'ahooks'
import { useMemo } from 'react'

export const useUserId: () => number = () => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
  const account = JSON.parse(sessionStorage.getItem('account') || '{}')
  return userInfo?.id || account?.userId || sessionStorage.getItem('userId') || 0
}
export const useUserInfo: () => UserInfo = () => {
  const userInfo = localStorage.getItem('userInfo') || sessionStorage.getItem('account') || '{}'
  return JSON.parse(userInfo)
}
export const useUserTeamId: () => number = () => {
  const auth = JSON.parse(localStorage.getItem('auth') || '{}')
  const teamInfo = JSON.parse(sessionStorage.getItem('teamInfo') || '{}')
  return auth?.teamId || teamInfo?.teamId || sessionStorage.getItem('teamId') || 0
}
const shareFrontEndConfigPlatform = sharePromise(() => request.cget('/backend-api/abroad-dataline/front-end-config/platform'))
export const usePlatformConfig = () => {
  const { data = [] } = useRequest(async () => {
    const res = await shareFrontEndConfigPlatform()
    return res as FrontEndConfigVO[]
  })
  const config = useMemo(() => {
    const config: Record<number, FrontEndConfigVO> = {}
    data.forEach((m) => {
      if ('platformType' in m) {
        if (m.platformType) {
          config[m.platformType] = m
        }
      }
    })
    return config
  }, [data])
  return {
    config,
    sheinSites: data
      ?.filter((f) => f.sheinPlatform)
      ?.map((m) => ({ label: m.platformName?.replace('SHEIN', '')?.replace('站', ''), value: `${m.platformType}` })),
  }
}
